
export type TrackMetricBodyTags = {[key: string]: string};
